// Objetivo:
// Criar um cache das páginas visitas para que quando o usuário volte a página não seja carregada novamente.
// Ter a opção de um toggle para mostrar ou esconder as páginas do cache.

class CacheManager {
    constructor() {
      this.cache = new Map();
      this.limit = 20;
    }
  
    set(key, component) {

      if (this.cache.size >= this.limit) {
        const firstKey = this.cache.keys().next().value;
        this.cache.delete(firstKey);
      }
      this.cache.set(key, component);
    }
  
    get(key) {
      return this.cache.get(key);
    }
  }
  
  export default new CacheManager();